export default "__VITE_ASSET__BsAYnB2K__"